import normalizeEntity from '@flow/libs/normalized-redux/entity-normalizer';

// Temporary `virtual` entity
const normalizedWorkspaceGroups = normalizeEntity({
  entity: 'workspaceGroup',
  rpcs: [
    'assignGroupWorkspaces',
  ],
});

export default normalizedWorkspaceGroups;
